import React from 'react';
import { PhoneCall } from 'lucide-react';

// Shown in place of the whole customer portal (or, for a login with several accounts, in place of
// the selected account's dashboard) when the service expired more than 90 days ago. The wording
// and number come from the API (backend utils/expiryOver90.js) so there is a single copy of them.
export default function Over90DaysScreen({ info }) {
  if (!info) return null;
  return (
    <div className="card" role="alert" style={{ padding: '28px 22px', textAlign: 'center', marginTop: 8 }}>
      <div style={{
        width: 54, height: 54, borderRadius: 14, background: '#fef3c7', display: 'flex',
        alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px',
      }}>
        <PhoneCall size={26} color="#b45309" />
      </div>
      <p style={{ fontSize: '1rem', lineHeight: 1.6, color: 'var(--text)', fontWeight: 600, margin: 0 }}>
        {info.message}
      </p>
      {info.contact && (
        <a href={`tel:${info.contact}`} className="btn btn-primary" style={{ marginTop: 18, display: 'inline-flex', justifyContent: 'center', gap: 8 }}>
          <PhoneCall size={16} /> Call {info.contact}
        </a>
      )}
    </div>
  );
}
